document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Scroll reveal ---------- */
  const revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(el => io.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('in'));
  }

  /* ---------- Mobile drawer ---------- */
  const burger = document.querySelector('[data-burger]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  const overlay = document.querySelector('[data-drawer-overlay]');
  const drawerClose = document.querySelector('[data-drawer-close]');

  function openDrawer() {
    drawer && drawer.classList.add('open');
    overlay && overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer && drawer.classList.remove('open');
    overlay && overlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  burger && burger.addEventListener('click', openDrawer);
  drawerClose && drawerClose.addEventListener('click', closeDrawer);
  overlay && overlay.addEventListener('click', function () {
    closeDrawer();
    const openFilterSidebar = document.querySelector('[data-filter-sidebar].open');
    openFilterSidebar && openFilterSidebar.classList.remove('open');
  });

  document.querySelectorAll('.mobile-accordion > button').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.parentElement.classList.toggle('open');
    });
  });

  /* ---------- Testimonial slider arrows ---------- */
  document.querySelectorAll('[data-testi-track]').forEach(track => {
    const prev = track.parentElement.querySelector('[data-testi-prev]');
    const next = track.parentElement.querySelector('[data-testi-next]');
    const scrollAmt = () => track.querySelector('.testi-card') ? track.querySelector('.testi-card').offsetWidth + 24 : 340;
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -scrollAmt(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: scrollAmt(), behavior: 'smooth' }));
  });

  /* ---------- Mobile filter drawer on collection page ---------- */
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterSidebar = document.querySelector('[data-filter-sidebar]');
  const filterClose = document.querySelector('[data-filter-close]');
  filterToggle && filterToggle.addEventListener('click', () => filterSidebar.classList.add('open'));
  filterClose && filterClose.addEventListener('click', () => filterSidebar.classList.remove('open'));

  /* ---------- Sort select (collection page) ---------- */
  const sortSelect = document.querySelector('[data-sort-select]');
  sortSelect && sortSelect.addEventListener('change', function () {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    window.location.href = url.toString();
  });

  /* ---------- Quick filter pills: New / Best Sellers / Sale / In Stock ---------- */
  const quickBar = document.querySelector('[data-quick-filters]');
  if (quickBar) {
    const pills = quickBar.querySelectorAll('[data-quick-filter]');
    const cards = document.querySelectorAll('[data-prod-card]');
    const emptyMsg = document.querySelector('[data-quick-empty]');
    const resultCount = document.querySelector('[data-result-count]');
    const baseCount = resultCount ? resultCount.textContent.trim() : null;

    pills.forEach(pill => {
      pill.addEventListener('click', function () {
        pills.forEach(p => p.classList.remove('active'));
        this.classList.add('active');
        const type = this.getAttribute('data-quick-filter');
        let visibleCount = 0;

        cards.forEach(card => {
          let show = true;
          if (type === 'new') show = card.getAttribute('data-new') === 'true';
          else if (type === 'bestseller') show = card.getAttribute('data-bestseller') === 'true';
          else if (type === 'sale') show = card.getAttribute('data-sale') === 'true';
          else if (type === 'instock') show = card.getAttribute('data-available') === 'true';

          card.style.display = show ? '' : 'none';
          if (show) visibleCount++;
        });

        if (emptyMsg) emptyMsg.style.display = (visibleCount === 0 && cards.length > 0) ? 'flex' : 'none';
        if (resultCount) resultCount.textContent = type === 'all' ? baseCount : visibleCount;
      });
    });
  }

  /* ---------- Grid / List view toggle ---------- */
  const viewToggle = document.querySelector('[data-view-toggle]');
  const prodGrid = document.querySelector('[data-prod-grid]');
  if (viewToggle && prodGrid) {
    const viewBtns = viewToggle.querySelectorAll('[data-view]');
    let savedView = null;
    try { savedView = localStorage.getItem('packpoly-view'); } catch (e) {}
    if (savedView === 'list') {
      prodGrid.classList.add('list-view');
      viewBtns.forEach(b => b.classList.toggle('active', b.getAttribute('data-view') === 'list'));
    }
    viewBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        const view = this.getAttribute('data-view');
        viewBtns.forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        prodGrid.classList.toggle('list-view', view === 'list');
        try { localStorage.setItem('packpoly-view', view); } catch (e) {}
      });
    });
  }

  /* ---------- Price range dual slider (syncs with Shopify min/max filter inputs) ---------- */
  document.querySelectorAll('[data-price-slider]').forEach(wrap => {
    const minRange = wrap.querySelector('[data-price-min-range]');
    const maxRange = wrap.querySelector('[data-price-max-range]');
    const minField = wrap.querySelector('[data-price-min-field]');
    const maxField = wrap.querySelector('[data-price-max-field]');
    const fill = wrap.querySelector('[data-price-fill]');
    if (!minRange || !maxRange) return;

    const rangeMin = parseFloat(wrap.dataset.min) || 0;
    const rangeMax = parseFloat(wrap.dataset.max) || 100000;

    function updateFill() {
      const lo = parseFloat(minRange.value);
      const hi = parseFloat(maxRange.value);
      const span = (rangeMax - rangeMin) || 1;
      const left = ((lo - rangeMin) / span) * 100;
      const right = ((hi - rangeMin) / span) * 100;
      if (fill) {
        fill.style.left = left + '%';
        fill.style.width = Math.max(0, right - left) + '%';
      }
    }

    minRange.addEventListener('input', function () {
      if (parseFloat(minRange.value) > parseFloat(maxRange.value)) minRange.value = maxRange.value;
      if (minField) minField.value = minRange.value;
      updateFill();
    });
    maxRange.addEventListener('input', function () {
      if (parseFloat(maxRange.value) < parseFloat(minRange.value)) maxRange.value = minRange.value;
      if (maxField) maxField.value = maxRange.value;
      updateFill();
    });
    minField && minField.addEventListener('input', function () {
      minRange.value = minField.value || rangeMin;
      updateFill();
    });
    maxField && maxField.addEventListener('input', function () {
      maxRange.value = maxField.value || rangeMax;
      updateFill();
    });

    updateFill();
  });

  /* ---------- Wishlist heart toggle (saved locally) ---------- */
  let wishlist = [];
  try { wishlist = JSON.parse(localStorage.getItem('packpoly-wishlist') || '[]'); } catch (e) {}
  document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
    const id = btn.getAttribute('data-wishlist-btn');
    if (wishlist.indexOf(id) !== -1) btn.classList.add('active');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const idx = wishlist.indexOf(id);
      if (idx === -1) { wishlist.push(id); btn.classList.add('active'); }
      else { wishlist.splice(idx, 1); btn.classList.remove('active'); }
      try { localStorage.setItem('packpoly-wishlist', JSON.stringify(wishlist)); } catch (e) {}
    });
  });

  /* ---------- Quantity steppers on product form ---------- */
  document.querySelectorAll('[data-qty-wrap]').forEach(wrap => {
    const input = wrap.querySelector('input');
    wrap.querySelector('[data-qty-minus]').addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    wrap.querySelector('[data-qty-plus]').addEventListener('click', () => {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  /* ---------- Hero carousel ---------- */
  document.querySelectorAll('[data-hero-carousel]').forEach(carousel => {
    const track = carousel.querySelector('[data-hero-track]');
    const slides = track ? Array.from(track.children) : [];
    const dots = Array.from(carousel.querySelectorAll('[data-hero-dot]'));
    const prevBtn = carousel.querySelector('[data-hero-prev]');
    const nextBtn = carousel.querySelector('[data-hero-next]');
    let index = 0;
    let timer = null;

    function goTo(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach((d, di) => d.classList.toggle('active', di === index));
    }
    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }
    function startAutoplay() {
      const interval = parseInt(carousel.dataset.interval, 10) || 5000;
      if (carousel.dataset.autoplay === 'true' && slides.length > 1) {
        timer = setInterval(next, interval);
      }
    }
    function stopAutoplay() { timer && clearInterval(timer); }

    nextBtn && nextBtn.addEventListener('click', () => { next(); stopAutoplay(); startAutoplay(); });
    prevBtn && prevBtn.addEventListener('click', () => { prev(); stopAutoplay(); startAutoplay(); });
    dots.forEach(d => d.addEventListener('click', () => { goTo(parseInt(d.dataset.heroDot, 10)); stopAutoplay(); startAutoplay(); }));
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    goTo(0);
    startAutoplay();
  });

  /* ---------- Bag weight & pieces-per-kilogram calculator (gated) ---------- */
  const calcGate = document.querySelector('[data-calc-gate]');
  if (calcGate) {
    const gateForm = calcGate.querySelector('[data-calc-gate-form]');
    const toolWrap = document.querySelector('[data-calc-tool]');
    const unlocked = localStorage.getItem('packpoly_calc_unlocked') === 'true';

    function unlockTool() {
      calcGate.style.display = 'none';
      toolWrap && toolWrap.classList.add('unlocked');
      localStorage.setItem('packpoly_calc_unlocked', 'true');
    }
    if (unlocked) unlockTool();

    gateForm && gateForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const name = gateForm.querySelector('[name="calc_name"]').value.trim();
      const phone = gateForm.querySelector('[name="calc_phone"]').value.trim();
      if (!name || !phone) return;
      // Send the lead to Shopify's native contact form silently in the background
      const bg = document.querySelector('[data-calc-lead-form]');
      if (bg) {
        bg.querySelector('[name="contact[name]"]').value = name;
        bg.querySelector('[name="contact[phone]"]').value = phone;
        bg.querySelector('[name="contact[email]"]').value = gateForm.querySelector('[name="calc_email"]').value.trim();
        bg.querySelector('[name="contact[body]"]').value = 'Bag Weight Calculator access request. Company: ' + (gateForm.querySelector('[name="calc_company"]') ? gateForm.querySelector('[name="calc_company"]').value.trim() : '');
        fetch(bg.action, { method: 'POST', body: new FormData(bg), mode: 'no-cors' }).catch(() => {});
      }
      unlockTool();
    });
  }

  function calcBagWeight() {
    const w = parseFloat(document.getElementById('calc-width').value) || 0;
    const l = parseFloat(document.getElementById('calc-length').value) || 0;
    const g = parseFloat(document.getElementById('calc-gauge').value) || 0;
    const density = 0.92; // g/cm3 typical PE density
    const out = document.getElementById('calc-output');
    if (!out) return;
    if (!w || !l || !g) { out.innerHTML = ''; return; }
    // gauge -> microns: 1 gauge = 0.254 microns
    const microns = g * 0.254;
    const thicknessCm = microns / 10000;
    const widthCm = w;
    const lengthCm = l;
    const volumeCm3 = widthCm * lengthCm * thicknessCm * 2; // 2 layers (front+back) for a flat bag
    const weightGrams = volumeCm3 * density;
    const piecesPerKg = weightGrams > 0 ? Math.floor(1000 / weightGrams) : 0;
    out.innerHTML =
      '<div class="calc-result-row"><span>Approx. weight per bag</span><b>' + weightGrams.toFixed(2) + ' g</b></div>' +
      '<div class="calc-result-row"><span>Approx. pieces per kilogram</span><b>' + piecesPerKg + ' pcs</b></div>';
  }
  document.querySelectorAll('#calc-width, #calc-length, #calc-gauge').forEach(el => {
    el && el.addEventListener('input', calcBagWeight);
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const main = document.querySelector('[data-gallery-main]');
      if (main && this.dataset.fullImg) {
        main.style.opacity = 0;
        setTimeout(() => {
          main.src = this.dataset.fullImg;
          main.style.opacity = 1;
        }, 150);
      }
      document.querySelectorAll('[data-gallery-thumb]').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

});
